// Modules that checks if we are on Yinxiang
// www-china.evernote.com
// www.yinxiang.com

module.exports = function isYXBJ() {
  return window.location.hostname == "www.yinxiang.com"
      || window.location.hostname == "www-china.evernote.com"
      || window.location.hostname == "stage-www.yinxiang.com"
      || $('body').hasClass('china_site');
};



// WEBPACK FOOTER //
// ./webroot/yinxiang/media/js/modules/is-yxbj.js